import {useQuery} from '@apollo/client';
import {FormNames, IRegisterForm} from 'packages/common-types/base-types';
import {Club} from 'packages/common-types/schema-types';
import {INPUT_FIELDS} from 'packages/constants/constants';
import {GET_CLUBS} from 'packages/graphql/v2/queries';
import {Controller, useFormContext} from 'react-hook-form';
import Select from 'react-select';

type GetClubsData = {
  getClubs: Club[];
};

const FormClubInformation = () => {
  const {control} = useFormContext<IRegisterForm>();
  const {data: registeredClubs, loading} = useQuery<GetClubsData>(GET_CLUBS);
  return (
    <>
      <Controller
        control={control}
        rules={{required: false}}
        name={INPUT_FIELDS[FormNames.CLUBNAME].name}
        render={({onChange, ref, value, ...rest}) => (
          <Select
            inputRef={ref}
            // eslint-disable-next-line no-underscore-dangle
            onChange={(newVal) => onChange(newVal._id)}
            options={registeredClubs?.getClubs}
            isLoading={loading}
            // eslint-disable-next-line no-underscore-dangle
            getOptionValue={(elem: Club) => elem._id}
            getOptionLabel={(elem: Club) => elem.name}
            value={registeredClubs?.getClubs.find(
              (c) => c.name === value && c.name.toUpperCase()
            )}
            {...rest}
          />
        )}
      />
    </>
  );
};

export default FormClubInformation;
